export interface IotAssetsApiResponse {
  result: string;
  errorDescription: string | null;
  dataResponseSizeInKb: string;
  elapsedTime: string;
  data: IotAssetRawData[];
  mappings?: {
    vehicles?: Record<string, string>;
    customers?: Record<string, string>;
    drivers?: Record<string, string>;
  };
  isFromCache: boolean;
}

// Nuova interfaccia per i dati raw dalla API
export interface IotAssetRawData {
  vin: string;
  can_map_name: string;
  scopes: IotAssetScope[];
}

export interface IotAssetScope {
  scope: string; // 'signal', 'platform', 'tcu', 'erp', etc.
  attributes: IotAssetAttribute[];
}

export interface IotAssetAttribute {
  name: string;
  value: string | null;
}

export interface IotAsset {
  // Base vehicle identification
  id_vehicle: number;
  vin: string;
  can_map_name: string;
  plate: string;
  uid:string;
  additional_signals:string;

  // Status and position information
  vehicle_status: 'MOVING' | 'PARKED' | 'IDLE' | 'UNKNOWN' | 'NOTCONNECTED';
  status_entered_at: string;
  last_key_event: string;
  last_key_event_type: number;
  last_known_speed: number;
  odo: number;
  fuel: number;
  lat_current: number;
  lon_current: number;
  angle_current: number;
  tstamp_current: string;
  updated_at: string;

  // Vehicle sensors & data
  fuel_level_1: number;
  fuel_level_2: number | null;
  ignition: boolean;
  rpm: number;
  gps_fix: boolean;
  gps_speed: number;
  hours: number;
  adblue_level: number | null;

  // Customer information
  id_customer: number;
  name_customer: string;
  code_customer: string;

  // Driver information
  tacho_state1: number;
  drv1_id: number | null;
  drv1_active: boolean;
  drv1_firstname: string | null;
  drv1_lastname: string | null;
  tacho_state2: number;
  drv2_id: number | null;
  drv2_active: boolean;
  drv2_firstname: string | null;
  drv2_lastname: string | null;
  uid_drv1: string | null;

  // Daily statistics
  total_moving_hours: string;
  total_parked_hours: string;
  total_idle_hours: string;
  total_distance_km: number;
  total_fuel_consumed_liters: number;
  first_record: string;
  last_record: string;

  // Optional/additional fields
  addressCurrent?: string;
  vehicle_selected?: boolean; // Maintain backward compatibility
  vehicleInfo?: any;
  driverInfo?: any;

  // high frequency data
  hf_active?: boolean;
  fromtime_last_update_status:number | null;
  fromtime_last_update_event:number | null;
}

export interface Journey {
  trip_id: number;
  v_id: number;
  vin: string;
  hours:string,
  fuel:number,
  plate: string;
  name_customer: string;
  id_customer: number;
  start_time: string;
  start_km: number;
  start_fuel: number;
  start_lat: number;
  start_lon: number;
  end_time: string;
  end_km: number;
  end_fuel: number;
  end_lat: number;
  end_lon: number;
  total_km: number;
  total_fuel_consumed: number;
  fuel_efficiency: number;
  drv1: string | null;
  drv2: string | null;
  journey_duration: string;
  status: 'CLOSED' | 'IN_PROGRESS' ; // Add other possible statuses if needed
  idle_time: string | null;
  keyon_duration: string | null;
  moving_time: string | null;
  parked_duration_before_next_journey: string | null;
  short_parked_duration: string | null;
  last_key_event: string,
  last_key_event_type: number,
  angle_current: number,
  selected?: boolean; // Optional property for selection
  addressStart?: string; // Optional property for start address
  addressEnd?: string; // Optional property for end address
}


export interface JourneyDetails {
  id: string;
  k: string | null;
  received_at_ms: string;
  pushed_at_ms: string;
  id_vehicle: number;
  vin: string;
  plate: string;
  id_customer: number;
  name_customer: string;
  code_customer: string;
  tstamp: string;
  cntr: number;
  hw_model: string;
  hw_r: string;
  hw_sn: string;
  hw_imei: string;
  hw_ccid: string;
  hw_canmap: string | null;
  evt: number;
  status: 'MOVING' | 'PARKED' | 'IDLE' | 'UNKNOWN' | 'NOTCONNECTED';
  gps_alt_v: number;
  gps_alt_u: string | null;
  gps_angle_v: number;
  gps_angle_u: string | null;
  gps_fix: boolean[];
  gps_lat: number;
  gps_lon: number;
  gps_sat: number;
  gps_speed_v: number;
  gps_speed_u: string | null;
  gps_tstamp: string;
  gps_hdop: number | null;
  gps_heading: number | null;
  dashboard_ign: boolean[];
  dashboard_fuel_v: number;
  dashboard_fuel_v_adj: number;
  dashboard_fuel_u: string | null;
  dashboard_odo_v: number;
  dashboard_odo_v_adj: number;
  dashboard_odo_u: string | null;
  dashboard_speed_v: number;
  dashboard_speed_v_adj: number;
  dashboard_speed_u: string | null;
  dashboard_flvl1_v: number;
  dashboard_flvl1_v_adj: number;
  dashboard_flvl1_u: string | null;
  dashboard_flvl2_v: number | null;
  dashboard_flvl2_v_adj: number | null;
  dashboard_flvl2_u: string | null;
  dashboard_rpm_v: number;
  dashboard_rpm_v_adj: number;
  dashboard_rpm_u: string | null;
  dashboard_hours_v: number;
  dashboard_hours_v_adj: number;
  dashboard_hours_u: string;
  dashboard_adlvl_v: number;
  dashboard_adlvl_v_adj: number;
  dashboard_adlvl_u: string | null;
  dashboard_idletime_v: number;
  dashboard_idletime_v_adj: number;
  dashboard_idletime_u: string | null;
  dashboard_idlefuel_v: number;
  dashboard_idlefuel_v_adj: number;
  dashboard_idlefuel_u: string | null;
  dashboard_eontime_v: number;
  dashboard_eontime_v_adj: number;
  dashboard_eontime_u: string | null;
  tacho_drv1: boolean[];
  tacho_id1: string | null;
  tacho_state1: number;
  tacho_drv1_id: string | null;
  tacho_drv1_firstname: string | null;
  tacho_drv1_lastname: string | null;
  tacho_drv1_id_customer: number | null;
  tacho_drv1_name_customer: string | null;
  tacho_drv1_code_customer: string | null;
  tacho_drv2: boolean[];
  tacho_id2: string | null;
  tacho_state2: number;
  tacho_drv2_id: string | null;
  tacho_drv2_firstname: string | null;
  tacho_drv2_lastname: string | null;
  tacho_drv2_id_customer: number | null;
  tacho_drv2_name_customer: string | null;
  tacho_drv2_code_customer: string | null;
  net_op: string;
}


export interface HighFrequency {
  vin: string;
  tstamp: string;
  cntr: number;
  hw_model: string;
  status: string;
  gps_alt_v: number;
  gps_angle_v: number;
  gps_lat: number;
  gps_lon: number;
  gps_speed_v: number;
}

export interface AdditionalSignalsConfig {
  id?: string;
  uidCustomer: string;
  uidUser: string;
  scope: string;
  config: {
    name: string;
    description?: string;
    signals: any;
    state?: string;
    type?: string;
    createdAt?: string;
    updatedAt?: string;
  };


}

export enum AdditionalSignalsScope {
  ADDITIONAL_SIGNALS = 'additional_signals_config',
  MAPPING_CONFIG = 'mapping_config',
  UCONTROL_SIGNALS_CONFIG = 'ucontrol-signals-config',
  JOURNEY_CONFIG = 'journey_config',
  CATALOG_CONFIG = 'catalog_config',
  DASHBOARD_CONFIG = 'dashboard_portal_config',
  GRAPHICS_CONFIG = 'graphics_config',
  HOMEPAGE20_LAYOUT = 'homepage20_layout_config',
  TREND20_LAYOUT = 'trend20_layout_config',
  MENU_CONFIG = 'menu_config',
}

export interface UControlSignalsConfig {
  id?: string;
  uidCustomer: string;
  uidUser: string;
  scope: string;
  audience: 'USER' | 'CUSTOMER' | 'GLOBAL';
  config: {
    name: string;
    brandUid: string;
    modelUid: string;
    modelCode?: string;
    signals: any;
    permissions: any;
    customers: string[];
  };
}

export interface MappingConfig {
  id?: string;
  uidCustomer?: string;
  uidUser: string;
  scope: string;
  audience:'USER' |'CUSTOMER'|'GLOBAL';
  config: {
    name: string;
    description?: string;
    mappingData: any; // Contenuto della configurazione di mapping
    state?: string;
    type?: string;
    createdAt?: string;
    updatedAt?: string;
    customers?: string[]; // Array di UID customers associati alla configurazione
  };
}

